<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="AddUserInfo" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-row>
        <el-col :span="8">
          <el-form-item label="登录账号" prop="SysUser.loginName">
            <el-input class="input-item" v-model="formData.SysUser.loginName"
              :clearable="true" placeholder="登录账号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="姓名" prop="SysUser.showName">
            <el-input class="input-item" v-model="formData.SysUser.showName"
              :clearable="true" placeholder="姓名"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别" prop="SysUser.gender">
            <el-radio-group class="input-item" v-model="formData.SysUser.gender"
              @change="onGenderValueChange"
            >
              <el-radio v-for="item in AddUserInfo.gender.impl.dropdownList" :key="item.id"
                :label="item.id"
              >
                {{item.name}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="邮箱" prop="SysUser.email">
            <el-input class="input-item" v-model="formData.SysUser.email"
              :clearable="true" placeholder="邮箱"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="移动电话" prop="SysUser.mobilePhone">
            <el-input class="input-item" v-model="formData.SysUser.mobilePhone"
              :clearable="true" placeholder="移动电话"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="固定电话" prop="SysUser.landlinePhone">
            <el-input class="input-item" v-model="formData.SysUser.landlinePhone"
              :clearable="true" placeholder="固定电话"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="出生日期" prop="SysUser.birthDate">
            <el-date-picker class="input-item" v-model="formData.SysUser.birthDate" :clearable="true"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd 00:00:00"
                            type="date" align="left"
                            placeholder="出生日期"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="用户状态" prop="SysUser.userStatus">
            <el-radio-group class="input-item" v-model="formData.SysUser.userStatus" @change="onUserStatusValueChange">
              <el-radio v-for="item in AddUserInfo.userStatus.impl.dropdownList" :key="item.id" :label="item.id">
                {{item.name}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="职位状态" prop="SysUser.jobStatus">
            <el-select class="input-item" v-model="formData.SysUser.jobStatus" filterable
                       placeholder="职位状态" :loading="AddUserInfo.jobStatus.impl.loading"
                       @visible-change="AddUserInfo.jobStatus.impl.onVisibleChange"
                       @change="onJobStatusValueChange">
              <el-option v-for="item in AddUserInfo.jobStatus.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="所属部门" prop="SysUser.deptId">
            <el-cascader class="input-item" v-model="formData.SysUser.deptId" :clearable="true" filterable
                         placeholder="所属部门" :loading="AddUserInfo.deptId.impl.loading" :props="{value: 'deptId', label: 'deptName', checkStrictly: true}"
                         @visible-change="AddUserInfo.deptId.impl.onVisibleChange" :options="AddUserInfo.deptId.impl.dropdownList"
              @change="onDeptIdValueChange"
            >
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="用户岗位" prop="SysUser.deptPostIdList">
            <el-select v-model="formData.SysUser.deptPostIdList" multiple placeholder="用户岗位">
              <el-option v-for="deptPost in deptPostList" :key="deptPost.deptPostId" style="width: 200px"
                         :label="deptPost.postShowName" :value="deptPost.deptPostId" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="入职时间" prop="SysUser.entryTime">
            <el-date-picker class="input-item" v-model="formData.SysUser.entryTime" :clearable="true"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd 00:00:00"
              type="date" align="left"
              placeholder="入职时间"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="转正时间" prop="SysUser.regularTime">
            <el-date-picker class="input-item" v-model="formData.SysUser.regularTime" :clearable="true"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd 00:00:00"
              type="date" align="left"
              placeholder="转正时间"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="融合岗位" prop="SysUser.fusionPost">
            <el-select class="input-item" v-model="formData.SysUser.fusionPost" :clearable="true" filterable
                       placeholder="融合岗位" :loading="AddUserInfo.fusionPost.impl.loading"
                       @visible-change="AddUserInfo.fusionPost.impl.onVisibleChange"
                       @change="onFusionPostValueChange">
              <el-option v-for="item in AddUserInfo.fusionPost.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="职位类别" prop="SysUser.jobTitleId">
            <el-cascader class="input-item" v-model="formData.SysUser.jobTitleId" :clearable="true" filterable
                          placeholder="职位类别" :loading="AddUserInfo.jobTitleId.impl.loading" :props="{value: 'id', label: 'name'}"
                          @visible-change="AddUserInfo.jobTitleId.impl.onVisibleChange" :options="AddUserInfo.jobTitleId.impl.dropdownList"
              @change="onJobTitleIdValueChange">
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="工龄" prop="SysUser.workYears">
            <el-input-number class="input-item" v-model="formData.SysUser.workYears"
                             :clearable="true"
                             placeholder="工龄"
            />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="薪资组" prop="SysUser.indexGroupId">
            <el-cascader class="input-item" v-model="formData.SysUser.indexGroupId" :clearable="true" filterable
              placeholder="薪资组" :loading="AddUserInfo.indexGroupId.impl.loading" :props="{value: 'id', label: 'name'}"
              @visible-change="AddUserInfo.indexGroupId.impl.onVisibleChange" :options="AddUserInfo.indexGroupId.impl.dropdownList"
              @change="onIndexGroupIdValueChange">
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="政治面貌" prop="SysUser.politicalType">
            <el-select class="input-item" v-model="formData.SysUser.politicalType" filterable
                       placeholder="政治面貌" :loading="AddUserInfo.politicalType.impl.loading"
                       @visible-change="AddUserInfo.politicalType.impl.onVisibleChange"
                       @change="onPoliticalTypeValueChange">
              <el-option v-for="item in AddUserInfo.politicalType.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="薪级" prop="SysUser.jobLevelId">
            <el-cascader class="input-item" v-model="formData.SysUser.jobLevelId" :clearable="true" filterable
                         placeholder="薪级" :loading="AddUserInfo.jobLevelId.impl.loading" :props="{value: 'id', label: 'name'}"
                         @visible-change="AddUserInfo.jobLevelId.impl.onVisibleChange" :options="AddUserInfo.jobLevelId.impl.dropdownList"
                         @change="onJobLevelIdValueChange">
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="考勤组" prop="SysUser.attnGroupId">
            <el-select class="input-item" v-model="formData.SysUser.attnGroupId" :clearable="true" filterable
                       placeholder="考勤组" :loading="AddUserInfo.attnGroupId.impl.loading"
                       @visible-change="AddUserInfo.attnGroupId.impl.onVisibleChange"
                       @change="onAttnGroupIdValueChange">
              <el-option v-for="item in AddUserInfo.attnGroupId.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
          <el-col :span="8">
            <el-form-item label="民族" prop="SysUser.nationType">
              <el-select class="input-item" v-model="formData.SysUser.nationType" :clearable="true" filterable
                         placeholder="民族" :loading="AddUserInfo.nationType.impl.loading"
                         @visible-change="AddUserInfo.nationType.impl.onVisibleChange"
                         @change="onNationTypeValueChange">
                <el-option v-for="item in AddUserInfo.nationType.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="入党时间" prop="SysUser.joinPartyTime">
              <el-date-picker class="input-item" v-model="formData.SysUser.joinPartyTime" :clearable="true"
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd 00:00:00"
                              type="date" align="left"
                              placeholder="入党时间"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="籍贯" prop="SysUser.hometown">
              <el-input class="input-item" v-model="formData.SysUser.hometown"
                        :clearable="true" placeholder="籍贯"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="参加工作时间" prop="SysUser.joinJobTime">
              <el-date-picker class="input-item" v-model="formData.SysUser.joinJobTime" :clearable="true"
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd 00:00:00"
                              type="date" align="left"
                              placeholder="参加工作时间"
              />
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="身份证号" prop="SysUser.idNum">
              <el-input class="input-item" v-model="formData.SysUser.idNum"
                        :clearable="true" placeholder="身份证号"
              />
            </el-form-item>
          </el-col>
        <el-col :span="16">
          <el-form-item label="薪级文件" prop="SysUser.jobLevelFilePath">
            <el-upload name="uploadFile" :headers="getUploadHeaders" multiple
              :action="getUploadActionUrl('/admin/upms/sysUser/upload')"
              :data="{fieldName: 'jobLevelFilePath', asImage: false}"
              :on-success="onJobLevelFilePathUploadSuccess"
              :on-remove="onJobLevelFilePathRemoveFile"
              :on-error="onUploadError" :on-exceed="onUploadLimit"
              :limit="AddUserInfo.jobLevelFilePath.impl.maxCount"
              :file-list="AddUserInfo.jobLevelFilePath.impl.fileList"
              :show-file-list="true" :on-preview="downloadJobLevelFile">
              <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="用户头像" prop="SysUser.headImageUrl">
            <el-upload
              class="upload-image-item" name="uploadFile" :headers="getUploadHeaders"
              :action="getUploadActionUrl('/admin/upms/sysUser/upload')"
              :data="{fieldName: 'headImageUrl', asImage: true}"
              :on-success="onHeadImageUrlUploadSuccess"
              :on-remove="onHeadImageUrlRemoveFile"
              :before-upload="pictureFile"
              :on-error="onUploadError"
              :onPreview="handlePictureCardPreview"
              :show-file-list="false">
              <div v-if="AddUserInfo.headImageUrl.impl.fileList && AddUserInfo.headImageUrl.impl.fileList[0] != null" style="position: relative">
                <img class="upload-image-show"
                  :src="AddUserInfo.headImageUrl.impl.fileList[0].url" />
                <div class="upload-img-del el-icon-close"
                  @click.stop="onHeadImageUrlRemoveFile(null, null)" />
              </div>
              <i v-else class="el-icon-plus upload-image-item"></i>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="岗位说明" prop="SysUser.postImgUrls">
            <el-upload name="uploadFile" :headers="getUploadHeaders" multiple
              :action="getUploadActionUrl('/admin/upms/sysUser/upload')"
              :data="{fieldName: 'postImgUrls', asImage: false}"
              :on-success="onPostImgUrlsUploadSuccess"
              :on-remove="onPostImgUrlsRemoveFile"
              :on-error="onUploadError" :on-exceed="onUploadLimit"
              :limit="AddUserInfo.postImgUrls.impl.maxCount"
              :file-list="AddUserInfo.postImgUrls.impl.fileList"
              :show-file-list="true" :on-preview="downloadJobLevelFile">
               <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        </el-row>
        <el-row>
          <el-divider>最高学历</el-divider>
        <el-col :span="8">
          <el-form-item label="最高学历" prop="SysUser.educationLvMax">
            <el-select class="input-item" v-model="formData.SysUser.educationLvMax" :clearable="true" filterable
                       placeholder="最高学历" :loading="AddUserInfo.educationLvMax.impl.loading"
                       @visible-change="AddUserInfo.educationLvMax.impl.onVisibleChange"
                       @change="onEducationLvMaxValueChange">
              <el-option v-for="item in AddUserInfo.educationLvMax.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="毕业院校" prop="SysUser.educationSchoolMax">
            <el-input class="input-item" v-model="formData.SysUser.educationSchoolMax"
                      :clearable="true" placeholder="毕业院校"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="专业" prop="SysUser.educationMajorMax">
            <el-input class="input-item" v-model="formData.SysUser.educationMajorMax"
                      :clearable="true" placeholder="专业"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="毕业时间" prop="SysUser.educationTimeMax">
            <el-date-picker class="input-item" v-model="formData.SysUser.educationTimeMax" :clearable="true"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd 00:00:00"
                            type="date" align="left"
                            placeholder="毕业时间"
            />
          </el-form-item>
        </el-col>
        </el-row>
        <el-row>
          <el-divider>第一学历</el-divider>
        <el-col :span="8">
          <el-form-item label="第一学历" prop="SysUser.educationLvFirst">
            <el-select class="input-item" v-model="formData.SysUser.educationLvFirst" :clearable="true" filterable
                       placeholder="第一学历" :loading="AddUserInfo.educationLvFirst.impl.loading"
                       @visible-change="AddUserInfo.educationLvFirst.impl.onVisibleChange"
                       @change="onEducationLvFirstValueChange">
              <el-option v-for="item in AddUserInfo.educationLvFirst.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="毕业院校" prop="SysUser.educationSchoolFirst">
            <el-input class="input-item" v-model="formData.SysUser.educationSchoolFirst"
                      :clearable="true" placeholder="毕业院校"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="专业" prop="SysUser.educationMajorFirst">
            <el-input class="input-item" v-model="formData.SysUser.educationMajorFirst"
                      :clearable="true" placeholder="专业"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="毕业时间" prop="SysUser.educationTimeFirst">
            <el-date-picker class="input-item" v-model="formData.SysUser.educationTimeFirst" :clearable="true"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd 00:00:00"
                            type="date" align="left"
                            placeholder="毕业时间"
            />
          </el-form-item>
        </el-col>
        </el-row>
        <el-row>
          <el-divider>第二学历</el-divider>
          <el-col :span="8">
            <el-form-item label="第二学历" prop="SysUser.educationLvSecond">
              <el-select class="input-item" v-model="formData.SysUser.educationLvSecond" :clearable="true" filterable
                         placeholder="第二学历" :loading="AddUserInfo.educationLvSecond.impl.loading"
                         @visible-change="AddUserInfo.educationLvSecond.impl.onVisibleChange"
                         @change="onEducationLvSecondValueChange">
                <el-option v-for="item in AddUserInfo.educationLvSecond.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
              </el-select>
            </el-form-item>
          </el-col>
        <el-col :span="8">
          <el-form-item label="毕业院校" prop="SysUser.educationSchoolSecond">
            <el-input class="input-item" v-model="formData.SysUser.educationSchoolSecond"
                      :clearable="true" placeholder="毕业院校"
            />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="专业" prop="SysUser.educationMajorSecond">
            <el-input class="input-item" v-model="formData.SysUser.educationMajorSecond"
                      :clearable="true" placeholder="专业"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="毕业时间" prop="SysUser.educationTimeSecond">
            <el-date-picker class="input-item" v-model="formData.SysUser.educationTimeSecond" :clearable="true"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd 00:00:00"
                            type="date" align="left"
                            placeholder="毕业时间"
            />
          </el-form-item>
        </el-col>
        </el-row>
        <el-row>
          <el-divider>现有职称</el-divider>
        <el-col :span="8">
          <el-form-item label="现有职称" prop="SysUser.jobTitleNameNow">
            <el-input class="input-item" v-model="formData.SysUser.jobTitleNameNow"
                      :clearable="true" placeholder="现有职称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="职称级别" prop="SysUser.jobTitleLvNow">
            <el-select class="input-item" v-model="formData.SysUser.jobTitleLvNow" :clearable="true" filterable
                       placeholder="职称级别" :loading="AddUserInfo.jobTitleLvNow.impl.loading"
                       @visible-change="AddUserInfo.jobTitleLvNow.impl.onVisibleChange"
                       @change="onJobTitleLvNowValueChange">
              <el-option v-for="item in AddUserInfo.jobTitleLvNow.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="取得时间" prop="SysUser.jobTitleTimeNow">
            <el-date-picker class="input-item" v-model="formData.SysUser.jobTitleTimeNow" :clearable="true"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd 00:00:00"
                            type="date" align="left"
                            placeholder="取得时间"
            />
          </el-form-item>
        </el-col>
        </el-row>
        <el-row>
          <el-divider>最高职称</el-divider>
        <el-col :span="8">
          <el-form-item label="最高职称" prop="SysUser.jobTitleNameMax">
            <el-input class="input-item" v-model="formData.SysUser.jobTitleNameMax"
                      :clearable="true" placeholder="最高职称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="职称级别" prop="SysUser.jobTitleLvMax">
            <el-select class="input-item" v-model="formData.SysUser.jobTitleLvMax" :clearable="true" filterable
                       placeholder="职称级别" :loading="AddUserInfo.jobTitleLvMax.impl.loading"
                       @visible-change="AddUserInfo.jobTitleLvMax.impl.onVisibleChange"
                       @change="onJobTitleLvMaxValueChange">
              <el-option v-for="item in AddUserInfo.jobTitleLvMax.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="初聘时间" prop="SysUser.jobTitleTimeMax">
            <el-date-picker class="input-item" v-model="formData.SysUser.jobTitleTimeMax" :clearable="true"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd 00:00:00"
                            type="date" align="left"
                            placeholder="初聘时间"
            />
          </el-form-item>
        </el-col>
        </el-row>
        <el-row>
          <el-divider>第一职称</el-divider>
        <el-col :span="8">
          <el-form-item label="第一职称" prop="SysUser.jobTitleNameFirst">
            <el-input class="input-item" v-model="formData.SysUser.jobTitleNameFirst"
                      :clearable="true" placeholder="第一职称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="职称级别" prop="SysUser.jobTitleLvFirst">
            <el-select class="input-item" v-model="formData.SysUser.jobTitleLvFirst" :clearable="true" filterable
                       placeholder="职称级别" :loading="AddUserInfo.jobTitleLvFirst.impl.loading"
                       @visible-change="AddUserInfo.jobTitleLvFirst.impl.onVisibleChange"
                       @change="onJobTitleLvFirstValueChange">
              <el-option v-for="item in AddUserInfo.jobTitleLvFirst.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="取得时间" prop="SysUser.jobTitleTimeFirst">
            <el-date-picker class="input-item" v-model="formData.SysUser.jobTitleTimeFirst" :clearable="true"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd 00:00:00"
                            type="date" align="left"
                            placeholder="取得时间"
            />
          </el-form-item>
        </el-col>
        </el-row>
        <el-row>
          <el-divider>第二职称</el-divider>
        <el-col :span="8">
          <el-form-item label="第二职称" prop="SysUser.jobTitleNameSecond">
            <el-input class="input-item" v-model="formData.SysUser.jobTitleNameSecond"
                      :clearable="true" placeholder="第二职称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="职称级别" prop="SysUser.jobTitleLvSecond">
            <el-select class="input-item" v-model="formData.SysUser.jobTitleLvSecond" :clearable="true" filterable
                       placeholder="职称级别" :loading="AddUserInfo.jobTitleLvSecond.impl.loading"
                       @visible-change="AddUserInfo.jobTitleLvSecond.impl.onVisibleChange"
                       @change="onJobTitleLvSecondValueChange">
              <el-option v-for="item in AddUserInfo.jobTitleLvSecond.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="取得时间" prop="SysUser.jobTitleTimeSecond">
            <el-date-picker class="input-item" v-model="formData.SysUser.jobTitleTimeSecond" :clearable="true"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd 00:00:00"
                            type="date" align="left"
                            placeholder="取得时间"
            />
          </el-form-item>
        </el-col>
        </el-row>
        <el-row>
          <el-divider>第三职称</el-divider>
        <el-col :span="8">
          <el-form-item label="第三职称" prop="SysUser.jobTitleNameThird">
            <el-input class="input-item" v-model="formData.SysUser.jobTitleNameThird"
                      :clearable="true" placeholder="第三职称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="职称级别" prop="SysUser.jobTitleLvThird">
            <el-select class="input-item" v-model="formData.SysUser.jobTitleLvThird" :clearable="true" filterable
                       placeholder="职称级别" :loading="AddUserInfo.jobTitleLvThird.impl.loading"
                       @visible-change="AddUserInfo.jobTitleLvThird.impl.onVisibleChange"
                       @change="onJobTitleLvThirdValueChange">
              <el-option v-for="item in AddUserInfo.jobTitleLvThird.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="取得时间" prop="SysUser.jobTitleTimeThird">
            <el-date-picker class="input-item" v-model="formData.SysUser.jobTitleTimeThird" :clearable="true"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd 00:00:00"
                            type="date" align="left"
                            placeholder="取得时间"
            />
          </el-form-item>
        </el-col>
        </el-row>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              取消
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('AddUserInfo:AddUserInfo:add')"
              @click="onAddClick()">
              新增
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList , treeDataTranslate} from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import {PaIndexGroupController,SysUserController, DictionaryController, SysDeptController, PaJobTitleController, PaJobLevelController} from '@/api';

export default {
  name: 'AddUserInfo',
  props: {
    // 是否支持级联操作
    supportCascadeAdd: {
      type: String,
      default: '0'
    },
    // 级联操作数据
    rowData: {
      type: Object
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      deptPostList: [],
      formData: {
        SysUser: {
          attnGroupId: undefined,
          fusionPost: undefined,
          postImgUrls: undefined,
          userId: undefined,
          loginName: undefined,
          password: undefined,
          deptId: undefined,
          deptTid: undefined,
          showName: undefined,
          userType: 2,
          headImageUrl: undefined,
          userStatus: 0,
          deletedFlag: undefined,
          createUserId: undefined,
          updateUserId: undefined,
          createTime: undefined,
          updateTime: undefined,
          jobLevelFilePath: undefined,
          gender: undefined,
          entryTime: undefined,
          jobStatus: '1',
          politicalType: undefined,
          workStatus: undefined,
          regularTime: undefined,
          workYears: 0,
          birthDate: undefined,
          jobLevelId: 0,
          jobTitleId: 0,
          indexGroupId: undefined,
          email: undefined,
          mobilePhone: undefined,
          landlinePhone: undefined,
          emContact1: undefined,
          emContact1Tel: undefined,
          emContact2: undefined,
          emContact2Tel: undefined,
          nationType: undefined,
          joinPartyTime: undefined,
          hometown: undefined,
          joinJobTime: undefined,
          educationLvMax: undefined,
          idNum: undefined,
          educationSchoolMax: undefined,
          educationMajorMax: undefined,
          educationLvFirst: undefined,
          educationTimeMax: undefined,
          educationSchoolFirst: undefined,
          educationMajorFirst: undefined,
          educationTimeFirst: undefined,
          educationLvSecond: undefined,
          educationSchoolSecond: undefined,
          educationMajorSecond: undefined,
          educationTimeSecond: undefined,
          jobTitleNameNow: undefined,
          jobTitleLvNow: undefined,
          jobTitleTimeNow: undefined,
          jobTitleNameMax: undefined,
          jobTitleLvMax: undefined,
          jobTitleTimeMax: undefined,
          jobTitleNameFirst: undefined,
          jobTitleLvFirst: undefined,
          jobTitleTimeFirst: undefined,
          jobTitleNameSecond: undefined,
          jobTitleLvSecond: undefined,
          jobTitleTimeSecond: undefined,
          jobTitleNameThird: undefined,
          jobTitleLvThird: undefined,
          jobTitleTimeThird: undefined,
          isDatasourceInit: false,
          sysUserPostList: [],
          deptPostIdList: [],
          deptPostIdListString: undefined,
          roleIdListString: undefined,
          dataPermIdListString: undefined
        }
      },
      rules: {
        'SysUser.workYears': [
          {type: 'number', message: '工龄只允许输入数字', trigger: 'blur', transform: (value) => Number(value)}
        ],
        'SysUser.loginName': [
          {required: true, message: '请输入登录账号', trigger: 'blur'},
          {type: 'string', pattern: rules.pattern.englishAndNumber, message: '登录账号只允许输入数字和英文字符', trigger: 'blur'}
        ],
        'SysUser.showName': [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        'SysUser.email': [
          {type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur'}
        ],
        'SysUser.mobilePhone': [
          {type: 'string', pattern: /^\d{11}$/, message: '请输入正确的手机号码', trigger: 'blur'}
        ],
        'SysUser.deptId': [
          {required: true, message: '请输入所属部门', trigger: 'blur'}
        ],
        'SysUser.gender': [
          {required: true, message: '请输入性别', trigger: 'blur'},
          {type: 'integer', message: '性别只允许输入整数', trigger: 'blur', transform: (value) => Number(value)}
        ],
        'SysUser.userStatus': [
          {required: true, message: '请输入用户状态', trigger: 'blur'}
        ],
        'SysUser.deptPostIdList': [
          {required: true, message: '用户岗位不能为空', trigger: 'change'}
        ]
      },
      AddUserInfo: {
        formFilter: {
        },
        formFilterCopy: {
        },
        gender: {
          impl: new DropdownWidget(this.loadGenderDropdownList)
        },
        deptId: {
          impl: new DropdownWidget(this.loadDeptIdDropdownList, true, 'deptId')
        },
        userStatus: {
          impl: new DropdownWidget(this.loadUserStatusDropdownList)
        },
        jobStatus: {
          impl: new DropdownWidget(this.loadJobStatusDropdownList)
        },
        fusionPost: {
          impl: new DropdownWidget(this.loadFusionPostDropdownList)
        },
        politicalType: {
          impl: new DropdownWidget(this.loadPoliticalTypeDropdownList)
        },
        jobTitleId: {
          impl: new DropdownWidget(this.loadJobTitleIdDropdownList, true, 'id', 'pid')
        },
        jobLevelId: {
          impl: new DropdownWidget(this.loadJobLevelIdDropdownList, true, 'id', 'pid')
        },
        indexGroupId: {
          impl: new DropdownWidget(this.loadIndexGroupIdDropdownList, true, 'id', 'pid')
        },
        attnGroupId: {
          impl: new DropdownWidget(this.loadAttnGroupIdDropdownList)
        },
        jobLevelFilePath: {
          impl: new UploadWidget(1)
        },
        headImageUrl: {
          impl: new UploadWidget(1)
        },
        postImgUrls: {
          impl: new UploadWidget(5)
        },
        nationType: {
          impl: new DropdownWidget(this.loadNationTypeDropdownList)
        },
        educationLvMax: {
          impl: new DropdownWidget(this.loadEducationLvMaxDropdownList)
        },
        educationLvFirst: {
          impl: new DropdownWidget(this.loadEducationLvFirstDropdownList)
        },
        educationLvSecond: {
          impl: new DropdownWidget(this.loadEducationLvSecondDropdownList)
        },
        jobTitleLvNow: {
          impl: new DropdownWidget(this.loadJobTitleLvNowDropdownList)
        },
        jobTitleLvMax: {
          impl: new DropdownWidget(this.loadJobTitleLvMaxDropdownList)
        },
        jobTitleLvFirst: {
          impl: new DropdownWidget(this.loadJobTitleLvFirstDropdownList)
        },
        jobTitleLvSecond: {
          impl: new DropdownWidget(this.loadJobTitleLvSecondDropdownList)
        },
        jobTitleLvThird: {
          impl: new DropdownWidget(this.loadJobTitleLvThirdDropdownList)
        },
        BtnDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    downloadJobLevelFile (file) {
      if (file.url.indexOf('blob:') === 0) {
        this.$message.error('请保存后,再下载文件!');
        return;
      }
      this.downloadFile(file.url, file.name);
    },
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    /**
     * 性别下拉数据获取函数
     */
    loadGenderDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictGender(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 性别选中值改变
     */
    onGenderValueChange (value) {
    },
    /**
     * 所属部门下拉数据获取函数
     */
    loadDeptIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        SysDeptController.list(this, params).then(res => {
          resolve(res.data.dataList);
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 所属部门选中值改变
     */
    onDeptIdValueChange (value) {
      this.formData.SysUser.deptPostIdList = undefined;
      this.loadDeptPost(value);
    },
    /**
     * 获取部门岗位列表
     */
    loadDeptPost (deptId) {
      if (deptId == null || deptId === '') {
        this.deptPostList = [];
        return;
      }
      deptId = Array.isArray(deptId) ? deptId[deptId.length - 1] : undefined;
      if (deptId !== undefined) {
        DictionaryController.dictDeptPost(this, {
          deptId: deptId
        }).then(res => {
          this.deptPostList = res;
        }).catch(e => {});
      }
    },
    /**
     * 用户状态下拉数据获取函数
     */
    loadUserStatusDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysUserStatus(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 用户状态选中值改变
     */
    onUserStatusValueChange (value) {
    },
    /**
     * 职位状态下拉数据获取函数
     */
    loadJobStatusDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_job_status'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 政治面貌
     */
    loadPoliticalTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_user_political_type'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 融合岗位下拉数据获取函数
     */
    loadFusionPostDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_user_fusion_post'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 融合岗位选中值改变
     */
    onFusionPostValueChange (value) {
    },
    /**
     * 职位状态选中值改变
     */
    onJobStatusValueChange (value) {
    },
    /**
     * 政治面貌
     */
    onPoliticalTypeValueChange (value) {
    },
    /**
     * 职称下拉数据获取函数
     */
    loadJobTitleIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        PaJobTitleController.list(this, params).then(res => {
          resolve(res.data.dataList);
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 职称选中值改变
     */
    onJobTitleIdValueChange (value) {
    },
    /**
     * 薪级下拉数据获取函数
     */
    loadJobLevelIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        PaJobLevelController.list(this, params).then(res => {
          resolve(res.data.dataList);
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 薪级选中值改变
     */
    onJobLevelIdValueChange (value) {
    },
    /**
     * 薪资组下拉数据获取函数
     */
    loadIndexGroupIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {
          paIndexGroupDtoFilter: {
            type: 'group'
          }
        };
        PaIndexGroupController.list(this, params).then(res => {
          resolve(res.data.dataList);
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 薪资组选中值改变
     */
    onIndexGroupIdValueChange (value) {
    },
    /**
     * 考勤组下拉数据获取函数
     */
    loadAttnGroupIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictPaAttnGroup(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 考勤组选中值改变
     */
    onAttnGroupIdValueChange (value) {
    },
    /**
     * 民族下拉数据获取函数
     */
    loadNationTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'sys_user_nation_type'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 民族选中值改变
     */
    onNationTypeValueChange (value) {
    },
    /**
     * 最高学历下拉数据获取函数
     */
    loadEducationLvMaxDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'sys_user_education_lv'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 最高学历选中值改变
     */
    onEducationLvMaxValueChange (value) {
    },
    /**
     * 第一学历下拉数据获取函数
     */
    loadEducationLvFirstDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'sys_user_education_lv'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 第一学历选中值改变
     */
    onEducationLvFirstValueChange (value) {
    },
    /**
     * 第二学历下拉数据获取函数
     */
    loadEducationLvSecondDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'sys_user_education_lv'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 第二学历选中值改变
     */
    onEducationLvSecondValueChange (value) {
    },
    /**
     * 现有职称_职称级别下拉数据获取函数
     */
    loadJobTitleLvNowDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'sys_user_job_title_lv'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 现有职称_职称级别选中值改变
     */
    onJobTitleLvNowValueChange (value) {
    },
    /**
     * 最高职称_职称级别下拉数据获取函数
     */
    loadJobTitleLvMaxDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'sys_user_job_title_lv'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 最高职称_职称级别选中值改变
     */
    onJobTitleLvMaxValueChange (value) {
    },
    /**
     * 第一职称_职称级别下拉数据获取函数
     */
    loadJobTitleLvFirstDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'sys_user_job_title_lv'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 第一职称_职称级别选中值改变
     */
    onJobTitleLvFirstValueChange (value) {
    },
    /**
     * 第二职称_职称级别下拉数据获取函数
     */
    loadJobTitleLvSecondDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'sys_user_job_title_lv'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 第二职称_职称级别选中值改变
     */
    onJobTitleLvSecondValueChange (value) {
    },
    /**
     * 第三职称_职称级别下拉数据获取函数
     */
    loadJobTitleLvThirdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'sys_user_job_title_lv'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 第三职称_职称级别选中值改变
     */
    onJobTitleLvThirdValueChange (value) {
    },
    /**
     * 更新添加员工信息
     */
    refreshAddUserInfo (reloadData = false) {
      if (!this.AddUserInfo.isInit) {
        // 初始化下拉数据
        this.AddUserInfo.gender.impl.onVisibleChange(true).catch(e => {});
        this.AddUserInfo.userStatus.impl.onVisibleChange(true).catch(e => {});
        this.AddUserInfo.jobStatus.impl.onVisibleChange(true).catch(e => {});
        this.AddUserInfo.attnGroupId.impl.onVisibleChange(true).catch(e => {});

        this.AddUserInfo.deptId.impl.onVisibleChange(true).then(res => {
          this.formData.SysUser.deptId = findTreeNodePath(this.AddUserInfo.deptId.impl.dropdownList, this.formData.SysUser.deptId, 'deptId');
          if (Array.isArray(this.formData.SysUser.sysUserPostList)) {
            this.formData.SysUser.deptPostIdList = this.formData.SysUser.sysUserPostList.map(item => item.deptPostId);
          }
          this.loadDeptPost(this.formData.SysUser.deptId);
        });
        this.AddUserInfo.jobTitleId.impl.onVisibleChange(true).then(res => {
          this.formData.SysUser.jobTitleId = findTreeNodePath(this.AddUserInfo.jobTitleId.impl.dropdownList, this.formData.SysUser.jobTitleId, 'id');
        });
        this.AddUserInfo.jobLevelId.impl.onVisibleChange(true).then(res => {
          this.formData.SysUser.jobLevelId = findTreeNodePath(this.AddUserInfo.jobLevelId.impl.dropdownList, this.formData.SysUser.jobLevelId, 'id');
        });
        this.AddUserInfo.indexGroupId.impl.onVisibleChange(true).then(res => {
          this.formData.SysUser.indexGroupId = findTreeNodePath(this.AddUserInfo.indexGroupId.impl.dropdownList, this.formData.SysUser.indexGroupId, 'id');
        });

        DictionaryController.dictSysDictByGroupCode(this, {groupCode: 'default_add_user_info'}).then(res => {
          let list = res.getList();
          for (let i = 0; i < list.length; i++) {
            let item = list[i];
            if (item.id === 'password') {
              this.formData.SysUser.password = item.name;
            } else if (item.id === 'roleIdListString') {
              this.formData.SysUser.roleIdListString = item.name;
            } else if (item.id === 'dataPermIdListString') {
              this.formData.SysUser.dataPermIdListString = item.name;
            }
          }
        });
      }
      this.AddUserInfo.isInit = true;
    },
    /**
     * 新增
     */
    onAddClick () {
      this.$refs.AddUserInfo.validate((valid) => {
        if (!valid) return;
        // 如果是级联表格的添加或者编辑弹窗
        if (this.supportCascadeAdd === '1') {
          let formData = {
            genderDictMap: findItemFromList(this.AddUserInfo.gender.impl.dropdownList, this.formData.SysUser.gender, 'id'),
            deptIdDictMap: findItemFromList(this.AddUserInfo.deptId.impl.dropdownList, this.formData.SysUser.deptId, 'id'),
            userStatusDictMap: findItemFromList(this.AddUserInfo.userStatus.impl.dropdownList, this.formData.SysUser.userStatus, 'id'),
            fusionPostDictMap: findItemFromList(this.AddUserInfo.fusionPost.impl.dropdownList, this.formData.SysUser.fusionPost, 'id'),
            jobStatusDictMap: findItemFromList(this.AddUserInfo.jobStatus.impl.dropdownList, this.formData.SysUser.jobStatus, 'id'),
            jobTitleIdDictMap: findItemFromList(this.AddUserInfo.jobTitleId.impl.dropdownList, this.formData.SysUser.jobTitleId, 'id'),
            jobLevelIdDictMap: findItemFromList(this.AddUserInfo.jobLevelId.impl.dropdownList, this.formData.SysUser.jobLevelId, 'id'),
            indexGroupIdDictMap: findItemFromList(this.AddUserInfo.indexGroupId.impl.dropdownList, this.formData.SysUser.indexGroupId, 'id'),
            attnGroupIdDictMap: findItemFromList(this.AddUserInfo.attnGroupId.impl.dropdownList, this.formData.SysUser.attnGroupId, 'id'),
            nationTypeDictMap: findItemFromList(this.AddUserInfo.nationType.impl.dropdownList, this.formData.SysUser.nationType, 'id'),
            educationLvMaxDictMap: findItemFromList(this.AddUserInfo.educationLvMax.impl.dropdownList, this.formData.SysUser.educationLvMax, 'id'),
            educationLvFirstDictMap: findItemFromList(this.AddUserInfo.educationLvFirst.impl.dropdownList, this.formData.SysUser.educationLvFirst, 'id'),
            educationLvSecondDictMap: findItemFromList(this.AddUserInfo.educationLvSecond.impl.dropdownList, this.formData.SysUser.educationLvSecond, 'id'),
            jobTitleLvNowDictMap: findItemFromList(this.AddUserInfo.jobTitleLvNow.impl.dropdownList, this.formData.SysUser.jobTitleLvNow, 'id'),
            jobTitleLvMaxDictMap: findItemFromList(this.AddUserInfo.jobTitleLvMax.impl.dropdownList, this.formData.SysUser.jobTitleLvMax, 'id'),
            jobTitleLvFirstDictMap: findItemFromList(this.AddUserInfo.jobTitleLvFirst.impl.dropdownList, this.formData.SysUser.jobTitleLvFirst, 'id'),
            jobTitleLvSecondDictMap: findItemFromList(this.AddUserInfo.jobTitleLvSecond.impl.dropdownList, this.formData.SysUser.jobTitleLvSecond, 'id'),
            jobTitleLvThirdDictMap: findItemFromList(this.AddUserInfo.jobTitleLvThird.impl.dropdownList, this.formData.SysUser.jobTitleLvThird, 'id'),
            ...this.formData.SysUser
          };
          this.onCancel(true, formData);
          return;
        }
        let deptTid = this.formData.SysUser.deptId;
        let deptId = this.formData.SysUser.deptId; deptId = Array.isArray(deptId) ? deptId[deptId.length - 1] : undefined;
        let jobLevelId = this.formData.SysUser.jobLevelId; jobLevelId = Array.isArray(jobLevelId) ? jobLevelId[jobLevelId.length - 1] : undefined;
        let jobTitleId = this.formData.SysUser.jobTitleId; jobTitleId = Array.isArray(jobTitleId) ? jobTitleId[jobTitleId.length - 1] : undefined;
        let indexGroupId = this.formData.SysUser.indexGroupId; indexGroupId = Array.isArray(indexGroupId) ? indexGroupId[indexGroupId.length - 1] : undefined;

        let params = {
          sysUserDto: {
            birthDate: this.formData.SysUser.birthDate,
            deptTid: deptTid,
            emContact1: this.formData.SysUser.emContact1,
            emContact1Tel: this.formData.SysUser.emContact1Tel,
            emContact2: this.formData.SysUser.emContact2,
            emContact2Tel: this.formData.SysUser.emContact2Tel,
            email: this.formData.SysUser.email,
            entryTime: this.formData.SysUser.entryTime,
            gender: this.formData.SysUser.gender,
            indexGroupId: indexGroupId,
            jobLevelFilePath: this.formData.SysUser.jobLevelFilePath,
            jobLevelId: jobLevelId,
            jobStatus: this.formData.SysUser.jobStatus,
            fusionPost: this.formData.SysUser.fusionPost,
            postImgUrls: this.formData.SysUser.postImgUrls,
            politicalType: this.formData.SysUser.politicalType,
            jobTitleId: jobTitleId,
            landlinePhone: this.formData.SysUser.landlinePhone,
            mobilePhone: this.formData.SysUser.mobilePhone,
            regularTime: this.formData.SysUser.regularTime,
            workStatus: this.formData.SysUser.workStatus,
            workYears: this.formData.SysUser.workYears,
            loginName: this.formData.SysUser.loginName,
            password: this.formData.SysUser.password,
            deptId: deptId,
            showName: this.formData.SysUser.showName,
            userType: this.formData.SysUser.userType,
            headImageUrl: this.formData.SysUser.headImageUrl,
            userStatus: this.formData.SysUser.userStatus,
            attnGroupId: this.formData.SysUser.attnGroupId,
            nationType: this.formData.SysUser.nationType,
            hometown: this.formData.SysUser.hometown,
            idNum: this.formData.SysUser.idNum,
            educationLvFirst: this.formData.SysUser.educationLvFirst,
            educationLvMax: this.formData.SysUser.educationLvMax,
            educationLvSecond: this.formData.SysUser.educationLvSecond,
            educationMajorFirst: this.formData.SysUser.educationMajorFirst,
            educationMajorMax: this.formData.SysUser.educationMajorMax,
            educationMajorSecond: this.formData.SysUser.educationMajorSecond,
            educationSchoolFirst: this.formData.SysUser.educationSchoolFirst,
            educationSchoolMax: this.formData.SysUser.educationSchoolMax,
            educationSchoolSecond: this.formData.SysUser.educationSchoolSecond,
            educationTimeFirst: this.formData.SysUser.educationTimeFirst,
            educationTimeMax: this.formData.SysUser.educationTimeMax,
            educationTimeSecond: this.formData.SysUser.educationTimeSecond,
            jobTitleLvFirst: this.formData.SysUser.jobTitleLvFirst,
            jobTitleLvMax: this.formData.SysUser.jobTitleLvMax,
            jobTitleLvNow: this.formData.SysUser.jobTitleLvNow,
            jobTitleLvSecond: this.formData.SysUser.jobTitleLvSecond,
            jobTitleLvThird: this.formData.SysUser.jobTitleLvThird,
            jobTitleNameFirst: this.formData.SysUser.jobTitleNameFirst,
            jobTitleNameMax: this.formData.SysUser.jobTitleNameMax,
            jobTitleNameNow: this.formData.SysUser.jobTitleNameNow,
            jobTitleNameSecond: this.formData.SysUser.jobTitleNameSecond,
            jobTitleNameThird: this.formData.SysUser.jobTitleNameThird,
            jobTitleTimeFirst: this.formData.SysUser.jobTitleTimeFirst,
            jobTitleTimeMax: this.formData.SysUser.jobTitleTimeMax,
            jobTitleTimeNow: this.formData.SysUser.jobTitleTimeNow,
            jobTitleTimeSecond: this.formData.SysUser.jobTitleTimeSecond,
            jobTitleTimeThird: this.formData.SysUser.jobTitleTimeThird,
            joinJobTime: this.formData.SysUser.joinJobTime,
            joinPartyTime: this.formData.SysUser.joinPartyTime
          },
          deptPostIdListString: Array.isArray(this.formData.SysUser.deptPostIdList) ? this.formData.SysUser.deptPostIdList.join(',') : undefined,
          roleIdListString: this.formData.SysUser.roleIdListString,
          dataPermIdListString: this.formData.SysUser.dataPermIdListString
        };

        SysUserController.add(this, params).then(res => {
          this.$message.success('新增成功');
          this.onCancel(true);
        }).catch(e => {});
      });
    },
    initFormData () {
    },
    /**
     * 薪级文件上传成功
     */
    onJobLevelFilePathUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.AddUserInfo.jobLevelFilePath.impl.onFileChange(file, fileList);
        this.formData.SysUser.jobLevelFilePath = this.fileListToJson(this.AddUserInfo.jobLevelFilePath.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 岗位说明上传成功
     */
    onPostImgUrlsUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.AddUserInfo.postImgUrls.impl.onFileChange(file, fileList);
        this.formData.SysUser.postImgUrls = this.fileListToJson(this.AddUserInfo.postImgUrls.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除岗位说明
     */
    onPostImgUrlsRemoveFile (file, fileList) {
      this.AddUserInfo.postImgUrls.impl.onFileChange(file, fileList);
      this.formData.SysUser.postImgUrls = this.fileListToJson(this.AddUserInfo.postImgUrls.impl.fileList);
    },
    /**
     * 移除薪级文件
     */
    onJobLevelFilePathRemoveFile (file, fileList) {
      this.AddUserInfo.jobLevelFilePath.impl.onFileChange(file, fileList);
      this.formData.SysUser.jobLevelFilePath = this.fileListToJson(this.AddUserInfo.jobLevelFilePath.impl.fileList);
    },
    /**
     * 用户头像上传成功
     */
    onHeadImageUrlUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.AddUserInfo.headImageUrl.impl.onFileChange(file, fileList);
        this.formData.SysUser.headImageUrl = this.fileListToJson(this.AddUserInfo.headImageUrl.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除用户头像
     */
    onHeadImageUrlRemoveFile (file, fileList) {
      this.AddUserInfo.headImageUrl.impl.onFileChange(file, fileList);
      this.formData.SysUser.headImageUrl = this.fileListToJson(this.AddUserInfo.headImageUrl.impl.fileList);
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        SysUser: {
          attnGroupId: undefined,
          fusionPost: undefined,
          postImgUrls: undefined,
          userId: undefined,
          loginName: undefined,
          password: undefined,
          deptId: undefined,
          deptTid: undefined,
          showName: undefined,
          userType: undefined,
          headImageUrl: undefined,
          userStatus: undefined,
          deletedFlag: undefined,
          createUserId: undefined,
          updateUserId: undefined,
          createTime: undefined,
          updateTime: undefined,
          jobLevelFilePath: undefined,
          gender: undefined,
          entryTime: undefined,
          jobStatus: undefined,
          politicalType: undefined,
          workStatus: undefined,
          regularTime: undefined,
          workYears: undefined,
          birthDate: undefined,
          jobLevelId: undefined,
          jobTitleId: undefined,
          indexGroupId: undefined,
          email: undefined,
          mobilePhone: undefined,
          landlinePhone: undefined,
          emContact1: undefined,
          emContact1Tel: undefined,
          emContact2: undefined,
          emContact2Tel: undefined,
          nationType: undefined,
          joinPartyTime: undefined,
          hometown: undefined,
          joinJobTime: undefined,
          educationLvMax: undefined,
          idNum: undefined,
          educationSchoolMax: undefined,
          educationMajorMax: undefined,
          educationLvFirst: undefined,
          educationTimeMax: undefined,
          educationSchoolFirst: undefined,
          educationMajorFirst: undefined,
          educationTimeFirst: undefined,
          educationLvSecond: undefined,
          educationSchoolSecond: undefined,
          educationMajorSecond: undefined,
          educationTimeSecond: undefined,
          jobTitleNameNow: undefined,
          jobTitleLvNow: undefined,
          jobTitleTimeNow: undefined,
          jobTitleNameMax: undefined,
          jobTitleLvMax: undefined,
          jobTitleTimeMax: undefined,
          jobTitleNameFirst: undefined,
          jobTitleLvFirst: undefined,
          jobTitleTimeFirst: undefined,
          jobTitleNameSecond: undefined,
          jobTitleLvSecond: undefined,
          jobTitleTimeSecond: undefined,
          jobTitleNameThird: undefined,
          jobTitleLvThird: undefined,
          jobTitleTimeThird: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshAddUserInfo();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // 初始化级联数据
    if (this.supportCascadeAdd === '1' && this.rowData != null) {
      this.formData.SysUser = {
        ...this.rowData
      }
    }
  },
  watch: {
  }
}
</script>
